/* Wolf loadout builder (sections/wolf-pdp-buy.liquid + snippets/wolf-bundle-*.liquid).
   Progressive enhancement over a pure-HTML form. Two modes, set by data-wolf-mode:
     addon  - page product is the vest; colour radios are name=id (vest variant), loadout
              radios are name=wolf_loadout. When the (colour, plate pair) has an in-stock
              variant on the bundle product, add-to-cart posts THAT ONE variant (the price
              Shopify charges for the bundle); otherwise vest + plates as two lines.
     native - page product is the bundle; loadout radios are name=id. The form posts
              natively (no fetch); this script only keeps prices, photo and labels in sync
              when the colour changes.
   Every price comes from Liquid: the per-colour map <script data-wolf-bundle-map> and the
   data-* attributes on the cards. Nothing is typed here.
   DR slots (spoke-dr-template): button / sticky labels, the "Was" prefix, saving-label
   patterns, the per-day line and the selection strip all read root data-* attributes that
   Liquid fills from section settings; total weights are the cards' data-total-weight
   (a block setting, never computed). Ladder tiles ([data-wolf-select-loadout]) anywhere
   in the document select a loadout in the buy box. */
(function () {
  'use strict';

  function asPositiveId(value) {
    var id = Number(value);
    if (!Number.isFinite(id) || id <= 0 || Math.floor(id) !== id) {
      throw new Error('A valid product option is required.');
    }
    return id;
  }

  function formatMoney(cents, currency, locale) {
    var amount = Number(cents);
    if (!Number.isFinite(amount)) amount = 0;
    try {
      return new Intl.NumberFormat(locale || 'en-US', {
        style: 'currency',
        currency: currency || 'USD'
      }).format(amount / 100);
    } catch (error) {
      return '$' + (amount / 100).toFixed(2);
    }
  }

  /* vestCents + plateCents is what the two cost apart; bundleCents (when > 0) is the
     bundle product's own price for the same goods. Savings are shown only when the
     bundle really is cheaper. In native mode vestCents is 0, plateCents is 0 and
     separateCents is the bundle variant's compare_at_price. */
  function computePricing(vestCents, plateCents, bundleCents, separateCents) {
    var vest = Number(vestCents) || 0;
    var plates = Number(plateCents) || 0;
    var bundle = Number(bundleCents) || 0;
    var separate = Number(separateCents) || 0;
    if (!separate) separate = vest + plates;
    var total = bundle > 0 ? bundle : vest + plates;
    var savings = separate > total ? separate - total : 0;
    return {
      compareCents: separate,
      totalCents: total,
      savingsCents: savings,
      usesBundle: bundle > 0
    };
  }

  function buildCartItems(vestVariantId, plateVariantId, bundleVariantId) {
    if (bundleVariantId) return [{ id: asPositiveId(bundleVariantId), quantity: 1 }];
    var items = [{ id: asPositiveId(vestVariantId), quantity: 1 }];
    if (plateVariantId) items.push({ id: asPositiveId(plateVariantId), quantity: 1 });
    return items;
  }

  function shopifyRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function cartUrl(path) {
    return new URL(path, new URL(shopifyRoot(), window.location.origin)).href;
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
    return String(value).replace(/[^a-zA-Z0-9_-]/g, function (c) { return '\\' + c; });
  }

  function labelFor(root, input) {
    if (!input || !input.id) return null;
    return root.querySelector('label[for="' + input.id + '"]');
  }

  function selectedColour(root) {
    return root.querySelector('[data-wolf-vest-variant]:checked:not(:disabled)');
  }

  function selectedLoadout(root) {
    return root.querySelector('[data-wolf-loadout-input]:checked:not(:disabled)');
  }

  function plateStyle(root) {
    var input = root.querySelector('[data-wolf-plate-style]:checked');
    return input && input.value === 'flat' ? 'flat' : 'curved';
  }

  /* Flat pairs have no Shopify bundle variant. Switch only configured addon cards;
     retain the original curved data so switching back restores today's path exactly. */
  var flatLookupWarnings = new WeakSet();
  function applyPlateStyle(root) {
    var picker = root.querySelector('[data-wolf-plate-styles]');
    if (!picker) return;
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-curved-variant-id]'));
    var hasFlat = cards.some(function (card) { return card.getAttribute('data-flat-resolved') === 'true'; });
    if (!hasFlat) root.querySelector('[data-wolf-plate-style][value="curved"]').checked = true;
    var style = plateStyle(root);
    cards.forEach(function (card) {
      var input = root.querySelector('#' + cssEscape(card.getAttribute('for')));
      var flatResolved = card.getAttribute('data-flat-resolved') === 'true';
      if (!flatResolved && !flatLookupWarnings.has(card)) {
        console.warn('[Wolf bundle] flat lookup failed for ' + (card.getAttribute('data-loadout-key') || 'unknown'));
        flatLookupWarnings.add(card);
      }
      var missing = style === 'flat' && !flatResolved;
      var available = !missing && card.getAttribute('data-' + style + '-available') === 'true';
      card.setAttribute('data-plate-variant-id', card.getAttribute('data-' + style + '-variant-id') || '');
      card.setAttribute('data-plate-price-cents', card.getAttribute('data-' + style + '-price-cents') || '0');
      if (input) input.disabled = !available;
      card.hidden = missing;
      card.classList.toggle('is-sold-out', !available && !missing);
      var line = card.querySelector('[data-wolf-plate-line]');
      if (line) line.textContent = card.getAttribute('data-' + style + '-plate-line') || '';
      var soldOut = card.querySelector('[data-wolf-loadout-unavailable]');
      if (soldOut) soldOut.hidden = available || missing;
      if (missing && input && input.checked) setStatus(root, 'Flat plates are not configured for that loadout. Choose another pair or Curved.');
    });
    var bundleNote = root.querySelector('[data-wolf-bundle-note]');
    if (bundleNote) bundleNote.hidden = style === 'flat';
    picker.hidden = !hasFlat;
  }

  function fallbackLoadoutLink(tile) {
    if (!tile.hasAttribute('data-fallback-link')) return '';
    var fallback = tile.getAttribute('data-fallback-link') || '';
    try {
      var url = new URL(fallback, window.location.href);
      if (!fallback || !/^https?:$/.test(url.protocol)) fallback = '';
    } catch (error) { fallback = ''; }
    tile.hidden = !fallback;
    tile.setAttribute('data-wolf-ladder-unavailable', 'true');
    tile.removeAttribute('aria-current');
    var price = tile.querySelector('.wp-tier-price');
    if (price) price.hidden = true;
    if (fallback) tile.href = fallback;
    else tile.removeAttribute('href');
    return fallback;
  }

  function unavailableLoadoutLink(tile) {
    tile.hidden = false;
    tile.classList.add('is-soldout');
    tile.setAttribute('aria-disabled', 'true');
    tile.setAttribute('data-wolf-ladder-unavailable', 'true');
    tile.removeAttribute('href');
    tile.removeAttribute('aria-current');
    var price = tile.querySelector('.wp-tier-price');
    if (price) {
      price.hidden = false;
      price.textContent = 'Sold out';
    }
  }

  function syncLoadoutLinks(root, state, updateAddress) {
    var style = plateStyle(root);
    Array.prototype.forEach.call(document.querySelectorAll('[data-wolf-select-loadout]'), function (tile) {
      // Only PDP ladder tiles opt into URL, price and fallback rewrites.
      if (!tile.hasAttribute('data-fallback-link')) return;
      var key = (tile.getAttribute('data-wolf-select-loadout') || '').toLowerCase();
      var input = root.querySelector('[data-wolf-loadout-input][data-loadout-key="' + cssEscape(key) + '"]');
      var card = labelFor(root, input);
      if (!card || !input) {
        fallbackLoadoutLink(tile);
        return;
      }
      if (input.disabled || card.hidden) {
        unavailableLoadoutLink(tile);
        return;
      }
      tile.hidden = false;
      tile.classList.remove('is-soldout');
      tile.removeAttribute('aria-disabled');
      tile.removeAttribute('data-wolf-ladder-unavailable');
      var url = new URL(window.location.href);
      url.searchParams.set('loadout', key);
      url.searchParams.set('plates', style);
      url.hash = 'wolf-buy-form';
      tile.href = url.pathname + url.search + url.hash;
      var price = tile.querySelector('.wp-tier-price');
      if (price) price.hidden = false;
      if (price) price.textContent = input.disabled ? 'Sold out' : formatMoney(
        cardPricing(root, card, state.colour, state.map).pricing.totalCents,
        root.getAttribute('data-currency') || 'USD', document.documentElement.lang || 'en-US');
    });
    if (updateAddress && root.querySelector('[data-wolf-plate-styles]')) {
      var current = new URL(window.location.href);
      current.searchParams.set('plates', style);
      if (state.loadoutKey) current.searchParams.set('loadout', state.loadoutKey);
      try { window.history.replaceState(window.history.state, '', current.href); } catch (error) {}
    }
  }

  function readMap(root) {
    var node = root.querySelector('script[data-wolf-bundle-map]');
    if (!node) return {};
    try {
      var parsed = JSON.parse(node.textContent || '{}');
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (error) {
      return {};
    }
  }

  function mapEntry(map, colour, pairTitle) {
    if (!map || !colour || !pairTitle) return null;
    var byColour = map[colour];
    if (!byColour || typeof byColour !== 'object') return null;
    var entry = byColour[pairTitle];
    if (!entry || typeof entry !== 'object') return null;
    var id = Number(entry.id);
    if (!Number.isFinite(id) || id <= 0) return null;
    return {
      id: id,
      price: Number(entry.price) || 0,
      compare: Number(entry.compare) || 0,
      available: entry.available === true,
      img: typeof entry.img === 'string' ? entry.img : '',
      alt: typeof entry.alt === 'string' ? entry.alt : ''
    };
  }

  function pushData(eventName, detail) {
    if (!Array.isArray(window.dataLayer)) return;
    window.dataLayer.push(Object.assign({ event: eventName }, detail || {}));
  }

  function ecommerceFromPayload(payload, currency) {
    var lines = payload && Array.isArray(payload.items) ? payload.items : (payload && payload.id ? [payload] : []);
    var valueCents = 0;
    var items = lines.map(function (line) {
      var quantity = Number(line.quantity) || 1;
      var unitCents = Number(line.final_price || line.price) || 0;
      valueCents += unitCents * quantity;
      return {
        item_id: String(line.variant_id || line.id || ''),
        item_name: String(line.product_title || line.title || 'Product'),
        item_variant: String(line.variant_title || ''),
        price: unitCents / 100,
        quantity: quantity
      };
    });
    return { currency: currency || 'USD', value: valueCents / 100, items: items };
  }

  function emitConfirmedAdd(form, payload, currency) {
    var ecommerce = ecommerceFromPayload(payload, currency);
    try {
      form.dispatchEvent(new CustomEvent('theme:add_to_cart', {
        detail: { ecommerce: ecommerce, source: 'wolf-bundle-builder' },
        bubbles: true,
        cancelable: false,
        composed: true
      }));
    } catch (error) {}
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({ event: 'add_to_cart', ecommerce: ecommerce });
    }
  }

  async function addItems(items) {
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timeout = controller ? window.setTimeout(function () { controller.abort(); }, 12000) : null;
    try {
      var response = await fetch(cartUrl('cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: items }),
        signal: controller ? controller.signal : undefined
      });
      var text = await response.text();
      var payload = {};
      if (text) {
        try { payload = JSON.parse(text); } catch (error) { payload = {}; }
      }
      if (!response.ok) {
        var message = payload.description || payload.message || 'Unable to add this system. Please try again.';
        var requestError = new Error(message);
        requestError.retrySafe = response.status >= 400 && response.status < 500;
        throw requestError;
      }
      if (!payload || (typeof payload !== 'object')) {
        var confirmError = new Error('We could not confirm whether this system was added.');
        confirmError.retrySafe = false;
        throw confirmError;
      }
      return payload;
    } finally {
      if (timeout) window.clearTimeout(timeout);
    }
  }

  function stickyTargets() {
    return Array.prototype.filter.call(document.querySelectorAll('[data-wolf-sticky-cta]'), function (sticky) {
      var button = sticky.querySelector('button[form="wolf-buy-form"]');
      return Boolean(button);
    });
  }

  function setBusy(root, busy, valid) {
    var form = root.querySelector('#wolf-buy-form');
    var controls = [
      root.querySelector('[data-wolf-bundle-submit]'),
      root.querySelector('[data-wolf-bundle-secondary-submit]')
    ];
    stickyTargets().forEach(function (sticky) {
      controls.push(sticky.querySelector('button[form="wolf-buy-form"]'));
    });
    if (form) {
      form.setAttribute('aria-busy', busy ? 'true' : 'false');
      if (busy) form.setAttribute('data-wolf-adding', 'true');
      else form.removeAttribute('data-wolf-adding');
    }
    controls.forEach(function (control) {
      if (!control) return;
      control.disabled = busy || !valid;
      control.setAttribute('aria-busy', busy ? 'true' : 'false');
    });
  }

  function cardPricing(root, card, colourInput, map) {
    var mode = root.getAttribute('data-wolf-mode') || 'addon';
    var colour = colourInput ? colourInput.getAttribute('data-colour') || '' : '';
    var vestCents = colourInput ? Number(colourInput.getAttribute('data-price-cents')) || 0 : 0;
    var plateCents = card ? Number(card.getAttribute('data-plate-price-cents')) || 0 : 0;
    var plateId = card ? card.getAttribute('data-plate-variant-id') || '' : '';
    var pairTitle = card ? card.getAttribute('data-pair-title') || '' : '';
    var entry = mode === 'addon' && plateStyle(root) === 'flat' ? null : mapEntry(map, colour, pairTitle);
    var bundleId = entry && entry.available ? entry.id : 0;
    var bundleCents = bundleId ? entry.price : 0;
    var separateCents = 0;
    if (mode === 'native') {
      /* native: the bundle variant is the only price of record; the struck figure is its
         compare-at, when the store set one above the price */
      separateCents = entry && entry.compare > entry.price ? entry.compare : 0;
      bundleId = entry ? entry.id : 0;
      bundleCents = entry ? entry.price : 0;
      vestCents = 0;
      plateCents = 0;
    }
    return {
      colour: colour,
      pairTitle: pairTitle,
      pairLabel: card ? card.getAttribute('data-pair-label') || '' : '',
      loadoutLabel: card ? card.getAttribute('data-loadout-label') || '' : '',
      totalWeight: card ? card.getAttribute('data-total-weight') || '' : '',
      loadoutKey: card ? card.getAttribute('data-loadout-key') || '' : '',
      vestCents: vestCents,
      plateCents: plateCents,
      plateId: plateId,
      entry: entry,
      bundleId: bundleId,
      pricing: computePricing(vestCents, plateCents, bundleCents, separateCents)
    };
  }

  function stateFor(root) {
    var mode = root.getAttribute('data-wolf-mode') || 'addon';
    var colourInput = selectedColour(root);
    var loadout = root.querySelector('[data-wolf-plate-styles]')
      ? root.querySelector('[data-wolf-loadout-input]:checked') : selectedLoadout(root);
    var card = labelFor(root, loadout);
    var map = readMap(root);
    var priced = cardPricing(root, card, colourInput, map);
    var isBundle = mode === 'native' ? Boolean(priced.bundleId) : Boolean(priced.plateId);
    var valid;
    if (mode === 'native') {
      valid = Boolean(colourInput && loadout && priced.bundleId && priced.entry && priced.entry.available);
    } else {
      valid = Boolean(colourInput && loadout && !loadout.disabled && priced.vestCents > 0);
    }
    return {
      mode: mode,
      colour: colourInput,
      loadout: loadout,
      card: card,
      map: map,
      vestCents: priced.vestCents,
      plateCents: priced.plateCents,
      plateId: priced.plateId,
      bundleId: priced.bundleId,
      pairLabel: priced.pairLabel,
      loadoutLabel: priced.loadoutLabel,
      totalWeight: priced.totalWeight,
      loadoutKey: priced.loadoutKey,
      plateStyle: plateStyle(root),
      pricing: priced.pricing,
      isBundle: isBundle,
      valid: valid
    };
  }

  /* native mode: colour changed -> every loadout radio (name=id) now stands for the
     bundle variant in the new colour. site.js validates the new values against the
     form's data-vids allowlist (they are this product's own ids). */
  function retargetNativeRows(root, state) {
    if (state.mode !== 'native' || !state.colour) return;
    var colour = state.colour.getAttribute('data-colour') || '';
    Array.prototype.forEach.call(root.querySelectorAll('[data-wolf-loadout]'), function (card) {
      var input = card.getAttribute('for') ? root.querySelector('#' + cssEscape(card.getAttribute('for'))) : null;
      var entry = mapEntry(state.map, colour, card.getAttribute('data-pair-title') || '');
      if (!input) return;
      if (!entry) {
        input.disabled = true;
        card.classList.add('is-sold-out');
        return;
      }
      input.value = String(entry.id);
      input.disabled = !entry.available;
      card.classList.toggle('is-sold-out', !entry.available);
      card.setAttribute('data-bundle-variant-id', String(entry.id));
      card.setAttribute('data-bundle-price-cents', String(entry.price));
      card.setAttribute('data-bundle-available', entry.available ? 'true' : 'false');
      card.setAttribute('data-separate-cents', String(entry.compare > entry.price ? entry.compare : 0));
      if (entry.img) {
        input.setAttribute('data-img', entry.img);
        input.setAttribute('data-img-alt', entry.alt || '');
      }
    });
    var checked = selectedLoadout(root);
    if (!checked) {
      var first = root.querySelector('[data-wolf-loadout-input]:not(:disabled)');
      if (first) first.checked = true;
    }
  }

  /* gallery follows the selection in native mode (site.js only reacts to name=id changes,
     and a colour change there is a name=wolf_color change) */
  function swapImage(root, input) {
    if (!input) return;
    var src = input.getAttribute('data-img');
    if (!src) return;
    var gallery = document.querySelector('.pdp-gallery');
    var main = gallery && gallery.querySelector('.g-main');
    var img = main && main.querySelector('img');
    if (!img) return;
    var norm = function (u) { try { return new URL(u, window.location.href).href; } catch (error) { return u; } };
    var ok = false;
    try {
      var parsed = new URL(src, document.baseURI);
      ok = parsed.protocol === 'https:' && (parsed.host === window.location.host || parsed.host === 'cdn.shopify.com');
    } catch (error) { ok = false; }
    if (!ok || norm(img.src) === norm(src)) return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = src;
    if (input.hasAttribute('data-img-alt')) img.alt = input.getAttribute('data-img-alt');
    main.classList.remove('zoomed');
    main.setAttribute('aria-pressed', 'false');
    img.style.transformOrigin = '50% 50%';
    /* DR gallery: the first thumb IS the variant photo ("Bundle shown"); retarget it so
       a later thumb click can return to the selected variant */
    var variantThumb = gallery.querySelector('.g-thumbs button[data-wolf-gallery-variant]');
    if (variantThumb) {
      variantThumb.setAttribute('data-full', src);
      var vt = variantThumb.querySelector('img');
      if (vt) {
        vt.src = src.replace(/([?&])width=1400/, '$1width=240');
        if (input.hasAttribute('data-img-alt')) vt.alt = input.getAttribute('data-img-alt');
      }
    }
    Array.prototype.forEach.call(gallery.querySelectorAll('.g-thumbs button'), function (b) {
      if (norm(b.getAttribute('data-full') || '') === norm(src)) b.setAttribute('aria-current', 'true');
      else b.removeAttribute('aria-current');
    });
  }

  function priceNote(root, state) {
    var noteVest = root.getAttribute('data-note-vest') || '';
    var noteBundle = root.getAttribute('data-note-bundle') || '';
    var noteSeparate = root.getAttribute('data-note-separate') || '';
    var currency = root.getAttribute('data-currency') || 'USD';
    var locale = document.documentElement.lang || 'en-US';
    if (!state.isBundle) return noteVest;
    var note = noteBundle.split('[pair]').join(state.pairLabel || '');
    if (state.pricing.savingsCents > 0 && noteSeparate) {
      note += ' ' + noteSeparate.split('[separate]').join(formatMoney(state.pricing.compareCents, currency, locale));
    }
    return note.trim();
  }

  function fillAmount(pattern, amountText) {
    return String(pattern || '').split('[amount]').join(amountText);
  }

  function saveText(root, cents, currency, locale) {
    var pattern = root.getAttribute('data-save-label') || 'Save [amount] vs buying separately';
    return fillAmount(pattern, formatMoney(cents, currency, locale));
  }

  function compareText(root, cents, currency, locale) {
    return (root.getAttribute('data-compare-prefix') || '') + formatMoney(cents, currency, locale);
  }

  /* "Black · 42 lb total" (the card's operator-set total weight; falls back to the
     loadout label when a card has none) */
  function selectionText(state) {
    var colourName = state.colour ? state.colour.getAttribute('data-colour') || '' : '';
    var tail = state.totalWeight || state.loadoutLabel || '';
    if (colourName && tail) return colourName + ' · ' + tail;
    return colourName || tail;
  }

  /* price truth (audit F2): "Vest only $X · bundles from $Y" while a plate loadout is
     checked. X is the checked colour's vest price, Y the cheapest in-stock bundle variant in
     that colour from the Liquid map; the pattern is the section setting on the root. */
  function priceAltText(root, state, currency, locale) {
    if (state.plateStyle === 'flat') return '';
    var pattern = root.getAttribute('data-price-alt-text') || '';
    if (!pattern || !state.colour) return '';
    var colour = state.colour.getAttribute('data-colour') || '';
    var byColour = state.map && state.map[colour];
    var from = 0;
    if (byColour && typeof byColour === 'object') {
      Object.keys(byColour).forEach(function (pairTitle) {
        var entry = mapEntry(state.map, colour, pairTitle);
        if (!entry || !entry.available || !(entry.price > 0)) return;
        if (!from || entry.price < from) from = entry.price;
      });
    }
    if (!from || !(state.vestCents > 0)) return '';
    return pattern.split('[vest]').join(formatMoney(state.vestCents, currency, locale))
      .split('[bundle]').join(formatMoney(from, currency, locale));
  }

  /* "Complete the system" rail (audit F14): while a plate loadout is checked the plates
     card re-offers what is already in the box, so it is hidden. Cards are found by an
     explicit hook ([data-system-card="<handle>"]) or by their product link; handles come
     from the add-on blocks (root data-wolf-plate-handles), never typed here. */
  function toggleSystemCards(root, state) {
    var handles = (root.getAttribute('data-wolf-plate-handles') || '').split(',').map(function (h) { return h.trim(); }).filter(Boolean);
    if (!handles.length) return;
    var hide = Boolean(state.isBundle);
    handles.forEach(function (handle) {
      var seen = [];
      Array.prototype.forEach.call(document.querySelectorAll('[data-system-card="' + cssEscape(handle) + '"]'), function (card) { seen.push(card); });
      Array.prototype.forEach.call(document.querySelectorAll('.card a.card-link[href]'), function (link) {
        var path = '';
        try { path = new URL(link.getAttribute('href'), window.location.href).pathname.replace(/\/+$/, ''); } catch (error) { return; }
        if ((path.split('/products/')[1] || '') !== handle) return;
        var card = link.closest('.card');
        if (card && seen.indexOf(card) < 0) seen.push(card);
      });
      seen.forEach(function (card) {
        if (root.contains(card)) return;
        card.hidden = hide;
        card.setAttribute('data-wolf-system-hidden', hide ? 'true' : 'false');
      });
    });
  }

  /* per-day line: price / 365 rounded UP, the same arithmetic Liquid uses on paint */
  function dailyText(root, totalCents, currency, locale) {
    var pattern = root.getAttribute('data-daily-text');
    if (!pattern || !(totalCents > 0)) return '';
    return fillAmount(pattern, formatMoney(Math.ceil(totalCents / 365), currency, locale));
  }

  /* ladder tiles (sections/wolf-dr-ladder.liquid) mirror the checked loadout */
  function markLadder(state) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-wolf-ladder-tile]'), function (tile) {
      var key = (tile.getAttribute('data-wolf-ladder-tile') || '').toLowerCase();
      var on = Boolean(key) && key === (state.loadoutKey || '').toLowerCase();
      if (on) tile.setAttribute('aria-current', 'true');
      else tile.removeAttribute('aria-current');
    });
  }

  function renderState(root) {
    applyPlateStyle(root);
    var state = stateFor(root);
    var currency = root.getAttribute('data-currency') || 'USD';
    var locale = document.documentElement.lang || 'en-US';

    Array.prototype.forEach.call(root.querySelectorAll('[data-wolf-loadout]'), function (card) {
      var priced = cardPricing(root, card, state.colour, state.map);
      var now = card.querySelector('[data-wolf-loadout-now]');
      var compare = card.querySelector('[data-wolf-loadout-compare]');
      var save = card.querySelector('[data-wolf-loadout-save]');
      var showSave = priced.pricing.savingsCents > 0;
      if (now) now.textContent = formatMoney(priced.pricing.totalCents, currency, locale);
      if (compare) {
        compare.hidden = !showSave;
        compare.textContent = showSave ? compareText(root, priced.pricing.compareCents, currency, locale) : '';
      }
      if (save) {
        save.hidden = !showSave;
        save.textContent = showSave ? saveText(root, priced.pricing.savingsCents, currency, locale) : '';
      }
    });

    var totalText = formatMoney(state.pricing.totalCents, currency, locale);
    Array.prototype.forEach.call(root.querySelectorAll('[data-wolf-bundle-total]'), function (node) {
      node.textContent = totalText;
    });
    var compareNode = root.querySelector('[data-wolf-bundle-compare]');
    var savingsNode = root.querySelector('[data-wolf-bundle-savings]');
    if (compareNode && savingsNode) {
      var showSavings = state.pricing.savingsCents > 0;
      compareNode.hidden = !showSavings;
      savingsNode.hidden = !showSavings;
      compareNode.textContent = showSavings ? compareText(root, state.pricing.compareCents, currency, locale) : '';
      savingsNode.textContent = showSavings ? saveText(root, state.pricing.savingsCents, currency, locale) : '';
    }
    var note = root.querySelector('[data-wolf-price-note]');
    if (note) note.textContent = priceNote(root, state);
    var alt = root.querySelector('[data-wolf-price-alt]');
    if (alt) {
      var altText = state.isBundle ? priceAltText(root, state, currency, locale) : '';
      alt.hidden = !altText;
      if (altText) alt.textContent = altText;
    }

    var fullLabel = state.isBundle
      ? (root.getAttribute('data-cta-bundle') || 'Add Vest + Plates to Cart')
      : (root.getAttribute('data-cta-vest') || 'Add Vest to Cart');
    var stickyLabel = state.isBundle
      ? (root.getAttribute('data-sticky-bundle') || 'Add Vest + Plates')
      : (root.getAttribute('data-sticky-vest') || 'Add Vest to Cart');
    var mainLabel = root.querySelector('[data-wolf-bundle-submit-label]');
    var secondaryLabel = root.querySelector('[data-wolf-bundle-secondary-label]');
    var secondaryTotal = root.querySelector('[data-wolf-bundle-secondary-total]');
    if (mainLabel) mainLabel.textContent = fullLabel;
    if (secondaryLabel) secondaryLabel.textContent = fullLabel;
    if (secondaryTotal) secondaryTotal.textContent = totalText;

    /* DR slots: per-day line, selection strip, colour meta, line-item properties */
    var daily = root.querySelector('[data-wolf-daily]');
    if (daily) daily.textContent = dailyText(root, state.pricing.totalCents, currency, locale);
    var selText = selectionText(state);
    var stripSel = root.querySelector('[data-wolf-strip-selection]');
    if (stripSel) stripSel.textContent = selText;
    var stripSave = root.querySelector('[data-wolf-strip-save]');
    if (stripSave) {
      var showStrip = state.pricing.savingsCents > 0;
      stripSave.hidden = !showStrip;
      stripSave.textContent = showStrip
        ? fillAmount(root.getAttribute('data-strip-save-label') || 'You save [amount]', formatMoney(state.pricing.savingsCents, currency, locale))
        : '';
    }
    var colourName = state.colour ? state.colour.getAttribute('data-colour') || '' : '';
    var colourMeta = root.querySelector('[data-wolf-colour-name]');
    if (colourMeta && colourName) colourMeta.textContent = colourName;
    /* round-swatch picker (addon mode): the name is one of the .pk-names spans */
    if (colourName) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-wolf-colour-names] > span'), function (sp) {
        sp.classList.toggle('is-on', sp.textContent === colourName);
      });
    }
    var stockLine = root.querySelector('[data-wolf-stock-line]');
    if (stockLine) stockLine.hidden = !state.valid;
    var propSavings = root.querySelector('[data-wolf-prop-savings]');
    if (propSavings) propSavings.value = state.pricing.savingsCents > 0 ? formatMoney(state.pricing.savingsCents, currency, locale) : '';
    var propWeight = root.querySelector('[data-wolf-prop-weight]');
    if (propWeight) propWeight.value = state.totalWeight || '';
    markLadder(state);
    syncLoadoutLinks(root, state, false);
    toggleSystemCards(root, state);

    stickyTargets().forEach(function (sticky) {
      var price = sticky.querySelector('[data-wolf-sticky-price]');
      var label = sticky.querySelector('[data-wolf-sticky-label]');
      /* audit F4: the bar carries product name + price + one button, nothing else; a
         [data-wolf-sticky-variant] slot is only filled when a template still renders one */
      var variant = sticky.querySelector('[data-wolf-sticky-variant]');
      if (price) price.textContent = totalText;
      if (label) label.textContent = stickyLabel;
      if (variant && selText) variant.textContent = selText;
    });

    setBusy(root, false, state.valid);
    if (state.loadout && state.loadout.disabled) {
      if (state.plateStyle === 'flat' && state.card && state.card.getAttribute('data-flat-resolved') === 'false') {
        setStatus(root, 'Flat plates are not configured for that loadout. Choose another pair or Curved.');
      } else {
        setStatus(root, state.plateStyle === 'flat'
          ? 'That pair is sold out in flat. Choose another pair or Curved.'
          : 'That pair is sold out in curved. Choose another pair or Flat.');
      }
    }
    return state;
  }

  /* ladder / any in-page tile: <a href="#wolf-buy-form" data-wolf-select-loadout="pro">.
     Selects that loadout in the buy box and scrolls to it; without JS the anchor alone
     lands the shopper on the form. */
  function bindLoadoutSelectors(root) {
    if (document.documentElement.getAttribute('data-wolf-loadout-selectors') === 'true') return;
    document.documentElement.setAttribute('data-wolf-loadout-selectors', 'true');
    var selectLoadout = function (event) {
      if (!root.isConnected) return;
      var tile = event.target && event.target.closest ? event.target.closest('[data-wolf-select-loadout]') : null;
      if (!tile) return;
      var key = (tile.getAttribute('data-wolf-select-loadout') || '').trim().toLowerCase();
      if (!key) return;
      var target = root.querySelector('[data-wolf-loadout-input][data-loadout-key="' + cssEscape(key) + '"]:not(:disabled)');
      if (!target) {
        if (!tile.hasAttribute('data-fallback-link')) return;
        event.preventDefault();
        var unavailable = root.querySelector('[data-wolf-loadout-input][data-loadout-key="' + cssEscape(key) + '"]');
        if (unavailable) {
          unavailableLoadoutLink(tile);
          return;
        }
        var fallback = fallbackLoadoutLink(tile);
        if (fallback) window.location.assign(fallback);
        return;
      }
      event.preventDefault();
      if (!target.checked) {
        target.checked = true;
        target.dispatchEvent(new Event('change', { bubbles: true }));
      }
      syncLoadoutLinks(root, stateFor(root), true);
      var card = labelFor(root, target);
      var dest = card || root.querySelector('#wolf-buy-form') || root;
      try { dest.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (error) { dest.scrollIntoView(); }
      try { target.focus({ preventScroll: true }); } catch (error) {}
    };
    document.addEventListener('click', selectLoadout);
    return function () {
      document.removeEventListener('click', selectLoadout);
      document.documentElement.removeAttribute('data-wolf-loadout-selectors');
    };
  }

  function setStatus(root, message) {
    var status = root.querySelector('[data-wolf-bundle-status]');
    if (status) status.textContent = message || '';
  }

  function bindExternalSubmitter(button, form) {
    if (!button || button.getAttribute('data-wolf-bundle-submit-bound') === 'true') return;
    button.setAttribute('data-wolf-bundle-submit-bound', 'true');
    var submitCurrentForm = function (event) {
      event.preventDefault();
      if (!form.isConnected) return;
      if (form.getAttribute('aria-busy') === 'true') return;

      var primarySubmitter = form.querySelector('[data-wolf-bundle-submit]');
      if (primarySubmitter && primarySubmitter !== button) {
        primarySubmitter.click();
        return;
      }

      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    };
    button.addEventListener('click', submitCurrentForm);
    return function () {
      button.removeEventListener('click', submitCurrentForm);
      button.removeAttribute('data-wolf-bundle-submit-bound');
    };
  }

  /* ?loadout=starter|athlete|pro|beast wins over the server default; ?variant=<bundle
     variant id> on the VEST page resolves to its colour + pair (Liquid only knows the
     vest's own ids). In native mode ?variant= is already handled server-side. */
  function applyDeepLink(root) {
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (error) { return; }
    var mode = root.getAttribute('data-wolf-mode') || 'addon';
    var style = params.get('plates') === 'flat' ? 'flat' : 'curved';
    var styleInput = root.querySelector('[data-wolf-plate-style][value="' + style + '"]');
    if (styleInput) {
      styleInput.checked = true;
      applyPlateStyle(root);
    }
    var map = readMap(root);
    var variantParam = params.get('variant');
    if (mode === 'addon' && variantParam) {
      var wanted = Number(variantParam);
      Object.keys(map).forEach(function (colour) {
        var pairs = map[colour];
        if (!pairs || typeof pairs !== 'object') return;
        Object.keys(pairs).forEach(function (pairTitle) {
          var entry = mapEntry(map, colour, pairTitle);
          if (!entry || entry.id !== wanted) return;
          var colourInput = root.querySelector('[data-wolf-vest-variant][data-colour="' + cssEscape(colour) + '"]:not(:disabled)');
          if (colourInput) colourInput.checked = true;
          var card = root.querySelector('[data-wolf-loadout][data-pair-title="' + cssEscape(pairTitle) + '"]');
          var input = card && card.getAttribute('for') ? root.querySelector('#' + cssEscape(card.getAttribute('for'))) : null;
          if (input && !input.disabled) input.checked = true;
        });
      });
    }
    var loadoutParam = (params.get('loadout') || '').trim().toLowerCase();
    if (loadoutParam) {
      var target = root.querySelector('[data-wolf-loadout-input][data-loadout-key="' + cssEscape(loadoutParam) + '"]');
      if (target && target.disabled && !styleInput) target = null;
      if (target) target.checked = true;
    }
  }

  var builderCleanups = new WeakMap();
  function initBuilder(root) {
    if (!root || root.getAttribute('data-wolf-bundle-ready') === 'true') return;
    var form = root.querySelector('#wolf-buy-form');
    if (!form) return;
    root.setAttribute('data-wolf-bundle-ready', 'true');
    var cleanups = [], externalCleanups = [], pageShowTimer = null, alive = true;
    function listen(target, type, handler) {
      target.addEventListener(type, handler);
      cleanups.push(function () { target.removeEventListener(type, handler); });
    }
    function own(cleanup) { if (cleanup) cleanups.push(cleanup); }
    var cleanupBuilder = function () {
      alive = false;
      cleanups.forEach(function (cleanup) { cleanup(); });
      externalCleanups.forEach(function (cleanup) { cleanup(); });
      if (pageShowTimer !== null) window.clearTimeout(pageShowTimer);
      root.removeAttribute('data-wolf-bundle-ready');
      builderCleanups.delete(root);
    };
    builderCleanups.set(root, cleanupBuilder);
    var mode = root.getAttribute('data-wolf-mode') || 'addon';

    if (mode === 'addon') {
      /* the fetch path below owns submission; the native action is parked so a stray
         native submit reloads the page instead of posting the vest alone */
      var nativeAction = form.getAttribute('data-wolf-native-action') || form.getAttribute('action') || cartUrl('cart/add');
      form.setAttribute('data-wolf-native-action', nativeAction);
      form.setAttribute('action', window.location.pathname + window.location.search + '#wolf-bundle');
    }

    applyDeepLink(root);
    var initial = stateFor(root);
    retargetNativeRows(root, initial);
    renderState(root);
    own(bindLoadoutSelectors(root));

    function refreshSubmitters() {
      externalCleanups.forEach(function (cleanup) { cleanup(); });
      externalCleanups = [];
      if (mode !== 'addon') return;
      function bind(button) {
        var cleanup = bindExternalSubmitter(button, form);
        if (cleanup) externalCleanups.push(cleanup);
      }
      bind(root.querySelector('[data-wolf-bundle-secondary-submit]'));
      stickyTargets().forEach(function (sticky) {
        bind(sticky.querySelector('button[form="wolf-buy-form"]'));
      });
    }
    cleanupBuilder.refreshSubmitters = refreshSubmitters;
    refreshSubmitters();

    listen(root, 'change', function (event) {
      var target = event.target;
      if (!target || (!target.hasAttribute('data-wolf-vest-variant') && !target.hasAttribute('data-wolf-loadout-input') && !target.hasAttribute('data-wolf-plate-style'))) return;
      setStatus(root, '');
      if (target.hasAttribute('data-wolf-vest-variant')) {
        var before = stateFor(root);
        retargetNativeRows(root, before);
        if (mode === 'native') swapImage(root, target);
      }
      var state = renderState(root);
      syncLoadoutLinks(root, state, true);
      if (mode === 'native' && target.hasAttribute('data-wolf-loadout-input')) swapImage(root, target);
      if (state.valid && (target.hasAttribute('data-wolf-loadout-input') ||
          (target.hasAttribute('data-wolf-plate-style') && state.isBundle))) {
        pushData('wolf_bundle_loadout_select', {
          loadout_key: state.loadoutKey,
          plate_style: state.plateStyle,
          plate_variant_id: state.plateId && !state.bundleId ? Number(state.plateId) : null,
          bundle_variant_id: state.bundleId || null,
          total_cents: state.pricing.totalCents
        });
      }
    });

    if (mode === 'addon') {
      listen(form, 'submit', async function (event) {
        event.preventDefault();
        if (form.getAttribute('aria-busy') === 'true') return;
        var state = stateFor(root);
        if (!state.valid) {
          var status = root.querySelector('[data-wolf-bundle-status]');
          if (!status || !status.textContent.trim()) setStatus(root, 'Choose an available color and loadout.');
          setBusy(root, false, false);
          return;
        }

        var items;
        try {
          items = buildCartItems(state.colour.value, state.plateId, state.bundleId);
        } catch (error) {
          setStatus(root, error.message || 'Choose an available color and loadout.');
          return;
        }

        setStatus(root, state.isBundle ? 'Adding your vest and plates…' : 'Adding your vest…');
        setBusy(root, true, true);
        try {
          var payload = await addItems(items);
          emitConfirmedAdd(form, payload, root.getAttribute('data-currency') || 'USD');
          pushData('wolf_bundle_add', {
            plate_style: state.plateStyle,
            vest_variant_id: Number(state.colour.value),
            plate_variant_id: state.plateId && !state.bundleId ? Number(state.plateId) : null,
            bundle_variant_id: state.bundleId || null,
            total_cents: state.pricing.totalCents
          });
          window.setTimeout(function () {
            var fallback = function () { window.location.assign(cartUrl('cart')); };
            if (typeof window.wolfOpenConfirmedCart !== 'function') { fallback(); return; }
            window.wolfOpenConfirmedCart(payload, function () {
              setStatus(root, 'Added to your cart.');
              setBusy(root, false, true);
            }, fallback);
          }, 80);
        } catch (error) {
          var message = error && error.message ? error.message : 'Unable to add this system. Please try again.';
          pushData('wolf_bundle_add_error', { message: message });
          if (error && error.retrySafe) {
            setStatus(root, message);
            setBusy(root, false, true);
          } else {
            setStatus(root, 'We could not confirm whether this system was added. Reload the page before trying again.');
            setBusy(root, true, true);
          }
        }
      });
    }

    /* site.js (deferred, later in the document) re-syncs .pdp-price-num from the checked
       name=id control on load and pageshow; run once more after it so the loadout total
       is what stays on screen */
    listen(window, 'load', function () { if (alive && root.isConnected) renderState(root); });
    function scheduleRefresh() {
      if (pageShowTimer !== null) window.clearTimeout(pageShowTimer);
      pageShowTimer = window.setTimeout(function () {
        pageShowTimer = null;
        if (!alive || !root.isConnected) return;
        setStatus(root, '');
        renderState(root);
      }, 0);
    }
    cleanupBuilder.scheduleRefresh = scheduleRefresh;
    listen(window, 'pageshow', scheduleRefresh);
  }

  function initAll(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(context.querySelectorAll('[data-wolf-bundle-builder]'), initBuilder);
    if (context.matches && context.matches('[data-wolf-bundle-builder]')) initBuilder(context);
  }

  window.WolfBundleBuilder = Object.freeze({
    formatMoney: formatMoney,
    computePricing: computePricing,
    buildCartItems: buildCartItems
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
    /* Generic variant mounts run later in this event and may write a vest-only price.
       Reapply the complete loadout after them, and bind any freshly replaced sticky. */
    Array.prototype.forEach.call(document.querySelectorAll('[data-wolf-bundle-builder]'), function (root) {
      var cleanup = builderCleanups.get(root);
      if (!cleanup) return;
      cleanup.refreshSubmitters();
      cleanup.scheduleRefresh();
    });
  });
  document.addEventListener('shopify:section:unload', function (event) {
    var scope = event.target;
    if (!scope || !scope.querySelectorAll) return;
    var roots = Array.prototype.slice.call(scope.querySelectorAll('[data-wolf-bundle-builder]'));
    if (scope.matches && scope.matches('[data-wolf-bundle-builder]')) roots.push(scope);
    roots.forEach(function (root) {
      var cleanup = builderCleanups.get(root);
      if (cleanup) cleanup();
    });
  });
})();
